import React from 'react'

const MernStack = () => {
  return (
    <div>
        {/* collapseTwentyOne */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingTwentyOne">
                <button 
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseTwentyOne" 
                    aria-expanded="false" 
                    aria-controls="collapseTwentyOne"
                >
                    MongoDB
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div 
                id="collapseTwentyOne" 
                className="accordion-collapse collapse" 
                aria-labelledby="headingTwentyOne" 
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Introduction, History, Purpose, Features</li>
                        <li>MongoDB advantages over RDBMS</li>
                        <li>Installation</li>
                        <li>Datatypes - String, Integer, Boolean, Double, etc.</li>
                        <li>Data Modeling</li>
                        <li>MongoDB Create Database, Drop Database</li>
                        <li>Create Collection, Drop Collection</li>
                        <li>CRUD using document - Insert, Update, Delete, Query documents</li>
                        <li>Aggregation Pipelines</li>
                        <li>Indexing & Search</li>
                        <li>MongoDB Drivers</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseTwentyTwo */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingTwentyTwo">
                <button 
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseTwentyTwo" 
                    aria-expanded="false" 
                    aria-controls="collapseTwentyTwo"
                >
                    Express.js
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div 
                id="collapseTwentyTwo" 
                className="accordion-collapse collapse" 
                aria-labelledby="headingTwentyTwo" 
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Introduction, Why Express.js</li>
                        <li>Installation</li>
                        <li>First app (Hello World), How the App Works?</li>
                        <li>Express Routing</li>
                        <li>Express HTTP Methods</li>
                        <li>URL Building, Middleware, Templating</li>
                        <li>Static Files</li>
                        <li>Express Resources</li>
                        <li>Authentication</li>
                        <li>RESTful APIs</li>
                        <li>Express Scaffolding</li>
                        <li>Express File Upload</li>
                        <li>Express Middleware</li>
                        <li>Express Session & Cookies Management</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseTwentyThree */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingTwentyThree">
                <button 
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseTwentyThree" 
                    aria-expanded="false" 
                    aria-controls="collapseTwentyThree"
                >
                    React JS
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div 
                id="collapseTwentyThree" 
                className="accordion-collapse collapse" 
                aria-labelledby="headingTwentyThree" 
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Introduction, History, Features</li>
                        <li>Installation - React environment, First React App</li>
                        <li>React ES6, JSX, Components</li>
                        <li>Angular vs React difference</li>
                        <li>Ways to rendering HTML</li>
                        <li>Functional vs class components, Props, State</li>
                        <li>Lifecycle methods, Hooks - useState, useEffect, useContext, useRef, useReducer, useCallback, etc.</li>
                        <li>Event handling</li>
                        <li>Forms - controlled components, submission, validation</li>
                        <li>Conditional rendering, Lists and keys, Importance of keys</li>
                        <li>Styling - CSS, CSS Modules, CSS-in-JS</li>
                        <li>React Router - setup, routes, parameters</li>
                        <li>What is Redux Toolkit and how Redux works?</li>
                        <li>Async/await, Promises, Fetch API</li>
                        <li>What is JSON and its methods</li>
                        <li>Axios package and CRUD operation using Axios</li>
                        <li>Life Cycle Method - Mounting Phase</li>
                        <li>Updating, Unmounting Phase</li>
                        <li>Error handling, debugging, optimization</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseTwentyFour */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingTwentyFour">
                <button 
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseTwentyFour" 
                    aria-expanded="false" 
                    aria-controls="collapseTwentyFour"
                >
                    Node.js
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div 
                id="collapseTwentyFour" 
                className="accordion-collapse collapse" 
                aria-labelledby="headingTwentyFour" 
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Introduction</li>
                        <li>Environment Setup, NPM vs NPX vs YARN</li>
                        <li>First Application</li>
                        <li>Callbacks Concept</li>
                        <li>Event Loop, Event Emitter</li>
                        <li>Buffers</li>
                        <li>Streams</li>
                        <li>File System</li>
                        <li>Global Objects</li>
                        <li>Utility Modules</li>
                        <li>Web Module</li>
                        <li>Node Server</li>
                        <li>RESTful API vs SOAP</li>
                        <li>Promise, Await & Async</li>
                        <li>What is CORS?, How CORS Works?, A Basic CORS Demonstration in Node.js</li>
                    </ul>
                </div>
            </div>
        </div>








    </div>
  )
}

export default MernStack